import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Checkbox, Form, Grid, Input } from "semantic-ui-react";
import moment from "moment";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import FormStore from "~/stores/FormStore";
import { getValidationErrors } from "~/utils/ReactReformed/ValidateSchema";
import ContentLoader from "~/components/element/ContentLoader";
import ImageUpload from "~/components/element/ImageUpload/ImageUpload";
import "../styles/UiMeet3dLinkPairForm.less";

@observer
class UiMeet3dLinkPairForm extends Component {
  render() {
    const {
      formStore,
      validationErrors,
      t,
      isSaving,
      defaultPhotoPathWeb,
      // defaultLogoPathWeb,
      uiMeet3dLinkPhotoPathWeb,
      // uiMeet3dLinkLogoPathWeb,
    } = this.props;
    const { setProperty, getAggregatedError, model, onBlur } = formStore;

    if (isSaving) {
      return <ContentLoader />;
    }

    const validationRules = {};
    const validation = getValidationErrors(validationRules, model);

    const canDeleteUiMeet3dLinkPhoto = uiMeet3dLinkPhotoPathWeb !== null;
    //  const canDeleteUiMeet3dLinkLogo = uiMeet3dLinkLogoPathWeb !== null;

    const finalDefaultPhotoPathWeb =
      uiMeet3dLinkPhotoPathWeb || defaultPhotoPathWeb || "/tourbuilder/assets/images/user_sil.jpg";
    // const finalDefaultLogoPathWeb =
    //  uiMeet3dLinkLogoPathWeb || defaultLogoPathWeb || "/tourbuilder/assets/images/user_sil.jpg";

    return (
      <Form className="fluid ui-meet-3d-link-pair-form">
        <h4>Organizer</h4>
        <Form.Group widths="equal">
          <Form.Field
            control={Input}
            name="name"
            label={t("name")}
            value={model.name}
            onBlur={onBlur}
            onChange={e => setProperty("name", e.target.value)}
            error={getAggregatedError("name", validation, validationErrors)}
          />
          <Form.Field
            control={Input}
            name="adminEmail"
            label={t("email")}
            value={model.email}
            onBlur={onBlur}
            onChange={e => setProperty("email", e.target.value)}
            error={getAggregatedError("email", validation, validationErrors)}
          />
        </Form.Group>
        <Form.Field
          control={Checkbox}
          label={t("clientPanelMisc:usePhotos")}
          checked={model.usePhotos}
          onChange={() => setProperty("usePhotos", !model.usePhotos)}
        />
        {model.usePhotos && (
          <>
            <Grid columns="equal">
              <Grid.Column>
                <div className="image-upload">
                  <h4>{t("clientPanelMisc:avatar")}</h4>
                  <Checkbox
                    disabled={!canDeleteUiMeet3dLinkPhoto}
                    label={t("clientPanelInfo:clickDelete")}
                    checked={canDeleteUiMeet3dLinkPhoto && model.deleteUiMeet3dLinkPhoto}
                    onChange={() => setProperty("deleteUiMeet3dLinkPhoto", !model.deleteUiMeet3dLinkPhoto)}
                  />
                  <ImageUpload
                    onFileSelected={encoded => setProperty("uiMeet3dLinkPhotoData", encoded)}
                    defaultSrc={finalDefaultPhotoPathWeb}
                    accept={["image/jpeg"]}
                  />
                </div>
              </Grid.Column>
              {/* <Grid.Column> */}
              {/*  <div className="image-upload"> */}
              {/*    <h4>{t("clientPanelMisc:backBadge")}</h4> */}
              {/*    <Checkbox */}
              {/*      disabled={!canDeleteUiMeet3dLinkLogo} */}
              {/*      label={t("clientPanelInfo:clickDelete")} */}
              {/*      checked={canDeleteUiMeet3dLinkLogo && model.deleteUiMeet3dLinkLogo} */}
              {/*      onChange={() => setProperty("deleteUiMeet3dLinkLogo", !model.deleteUiMeet3dLinkLogo)} */}
              {/*    /> */}
              {/*    <ImageUpload */}
              {/*      onFileSelected={encoded => setProperty("uiMeet3dLinkLogoData", encoded)} */}
              {/*      defaultSrc={finalDefaultLogoPathWeb} */}
              {/*      accept={["image/jpeg"]} */}
              {/*    /> */}
              {/*    <p>* {t("clientPanelMisc:backBadgeExplanation")}</p> */}
              {/*  </div> */}
              {/* </Grid.Column> */}
            </Grid>
          </>
        )}
        <h4>{t("miscellaneous")}</h4>
        <Form.Field
          control={Checkbox}
          label={t("clientPanelMisc:allowVisitorsTurnOnVideoAndAudio")}
          checked={!model.isGuidedTourMode}
          onChange={() => setProperty("isGuidedTourMode", !model.isGuidedTourMode)}
          disabled
        />
        <Form.Group widths="equal">
          <Form.Field
            control={Input}
            type="datetime-local"
            name="activationDts"
            label={t("clientPanelMisc:activationDate")}
            value={model.activationDts}
            onBlur={onBlur}
            onChange={e => setProperty("activationDts", e.target.value)}
            error={getAggregatedError("activationDts", validation, validationErrors)}
          />
          <Form.Field
            control={Input}
            type="datetime-local"
            name="expirationDts"
            label={t("clientPanelMisc:expirationDate")}
            value={model.expirationDts}
            onBlur={onBlur}
            onChange={e => setProperty("expirationDts", e.target.value)}
            error={getAggregatedError("expirationDts", validation, validationErrors)}
            min={moment()
              .add(1, "days")
              .format(moment.HTML5_FMT.DATETIME_LOCAL)}
            max={moment()
              .add(1, "years")
              .format(moment.HTML5_FMT.DATETIME_LOCAL)}
          />
        </Form.Group>
      </Form>
    );
  }
}

UiMeet3dLinkPairForm.propTypes = {
  t: PropTypes.func.isRequired,
  formStore: PropTypes.instanceOf(FormStore),
  validationErrors: PropTypes.object,
  isSaving: PropTypes.bool.isRequired,
  defaultPhotoPathWeb: PropTypes.string,
  // defaultLogoPathWeb: PropTypes.string,
  uiMeet3dLinkPhotoPathWeb: PropTypes.string,
  // uiMeet3dLinkLogoPathWeb: PropTypes.string,
};

export default withTranslation()(ErrorWrapper(UiMeet3dLinkPairForm));
